import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import _ from "lodash";
import { Form } from "react-advanced-form";
import { FormGroup } from "reactstrap";
import { Input } from "react-advanced-form-addons";
import Button from "react-bootstrap-button-loader";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent2 } from "BaseComponent2";
import {
  toggleEditAppBottomMenuEditor,
  createdMenuSave,
  updateAppBottomMenuDisplayName,
} from "BrandingAction";
import { updateBottomMenuLocally } from "GeneralTabAction";
import messages from "./validation-messages-menu";
import { maxLengthObjectFc } from "Constants";

var MAXLENOBJ = {};

class EditAppBottomMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      menuError: {},
    };
  }

  componentDidMount() {
    var { tab } = this.props;
    this.props.createdMenuSave(tab.displaytabname);

    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
  }

  //=====================   This portion belongs to the redux form functionalities =====================
  renderFieldText(field) {
    var divClassName = `form-group ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var inputClasses = "col-sm-7 col-sm-offset-0 iconfield";

    return (
      <div className={divClassName}>
        <div className={inputClasses} style={{ marginTop: "3px" }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  onChange = (e) => {
    /*var val=e.target.value;
    if(val.length>0){
      this.setState({loading:true});
      var valuesToSubmit={displaytabname:val,apptabid:this.props.tab.apptabid}
      this.props.updateContentTabName(this.props.session,valuesToSubmit,(response)=>{
            if(response.error){
              this.props.showError('There was an error updating Tab name!!');
            }
            this.setState({loading:false});
      });
    }*/
  };

  onFormSubmit(values) {
    // values.displaytabname = values.displaytabname.trim();
    // this.setState({loading:true});
    // var valuesToSubmit={...values,apptabid:this.props.tab.apptabid}
    // this.props.updateContentTabName(this.props.session,valuesToSubmit,(response)=>{
    //     if(!response.error){
    //       setTimeout(()=>{
    //           this.setState({loading:false});
    //           this.props.toggleEditAppBottomMenuEditor(false);
    //       },500);
    //     }else{
    //       this.setState({loading:false});
    //       this.props.showError('There was an error updating Tab name!');
    //     }
    // });
  }

  //===================== END *** This portion belongs to the redux form functionalities =====================

  closeEdit = () => {
    this.props.toggleEditAppBottomMenuEditor({ show: false, position: -1 });
  };

  handleValidation(values) {
    let { createdMenu } = this.props;
    let errors = {};
    let formIsValid = true;

    if (_.isEmpty(createdMenu)) {
      formIsValid = false;
      errors["displaytabname"] = "Please select a name";
    }

    this.setState({ menuError: errors });
    return formIsValid;
  }

  onSubmitForm = ({ serialized, fields, form }) => {
    let values = { ...serialized };
    var { createdMenu, session, tab, btmmenu } = this.props;

    var findeMe = tab.apptabid;
    var indexnew = btmmenu.findIndex(function (row) {
      return row.apptabid == findeMe;
    });

    btmmenu[indexnew].displaytabname = createdMenu;

    if (this.handleValidation(values)) {
      this.setState({ loading: true });

      let resourceObj = { displaytabname: createdMenu };
      this.props.updateAppBottomMenuDisplayName(
        session,
        tab.apptabid,
        resourceObj,
        (response) => {
          if (response.success) {
            this.setState({ loading: false });
            this.props.createdMenuSave({});
            this.props.showSuccess("Menu name updated successfully!");
            this.props.updateBottomMenuLocally(btmmenu);
            this.closeEdit();
          } else {
            this.setState({ loading: false });
            this.props.createdMenuSave({});
            this.props.showError("Something went wrong.");
            this.closeEdit();
          }
        }
      );
    } else {
      this.props.showError("Please enter valid menu name.");
    }
  };

  render() {
    var { tab } = this.props;

    return (
      <div>
        {/* this is <Form/> of react-advanced-form */}
        <Form
          ref={(form) => (this.form = form)}
          action={this.onSubmitForm}
          messages={messages}
          style={{ display: "flex" }}
        >
          <AddMenuForm {...this.props} menuError={this.state.menuError} />

          <Button
            className="btn-i-custom-blue"
            style={{ marginLeft: 6 }}
            type="submit"
            loading={this.state.loading}
            icon={<i className="fa fa-save"></i>}
          ></Button>

          <button
            type="button"
            className="i-custom-table-delete"
            style={{ marginLeft: 6 }}
            onClick={(e) => this.closeEdit(e)}
          >
            <img src="../../style/images/custom-icons/shape-1317-copy-3.svg" />
          </button>
        </Form>
      </div>
    );
  }
}

// function validate(values) {
//   var errors = {};

//   if (!values.displaytabname || values.displaytabname.trim() === "") {
//     errors.displaytabname = "Please input Tab Name!";
//   }

//   return errors;
// }

function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    // initialValues:{displaytabname:ownProps.tab.displaytabname},
    createdMenu: state.createdMenu,
    toEditAppBottomMenu: state.toEditAppBottomMenu,
  };
}

export default connect(mapStateToProps, {
  showSuccess,
  showError,
  createdMenuSave,
  updateAppBottomMenuDisplayName,
  toggleEditAppBottomMenuEditor,
  updateBottomMenuLocally,
})(
  //   reduxForm({
  //     form: "EditIconNameForm",
  //     validate,
  //     enableReinitialize: true,
  //   })

  EditAppBottomMenu
);

class AddMenuForm extends BaseComponent2 {
  constructor(props) {
    super(props);
    this.state = { text: props.tab.displaytabname };
  }

  handleInput = (e, field) => {
    // let { createdMenu } = this.props;
    let title = "";
    // title = e.nextValue;     //this is for <Input /> of 'react-advanced-form-addons'
    title = e.target.value; //this is for <input /> jsx

    this.setState({ text: title });
    this.props.createdMenuSave(title);
  };

  render() {
    let { tab } = this.props;
    let { text } = this.state;

    return (
      <div>
        {/* this <FormGroup/> commented as of now for some UI issues */}
        {/* <FormGroup className="mb-18">
          <Input
            placeholder={tab.displaytabname}
            type="text"
            name="displaytabname"
            rule={this.validateAlphaNumeric}
            // required
            onChange={(e) => this.handleInput(e, "displaytabname")}
          />
        </FormGroup> */}

        <div style={{ position: "relative" }}>
          <input
            style={{ width: 130 }}
            name="displaytabname"
            placeholder="Enter name"
            value={text}
            type="text"
            maxlength={MAXLENOBJ.displaytabname}
            onChange={(e) => this.handleInput(e, "displaytabname")}
          />
          {/* <span
            className="validation_error_msg"
            style={{ fontSize: 12, display: "block" }}
          >
            {this.props.menuError["displaytabname"]}
          </span> */}
          <span className="char-left-menuname">
            {this.state.text.length + " / " + MAXLENOBJ.displaytabname}
          </span>
        </div>
      </div>
    );
  }
}
